import { useState } from "react";
import { Typography, Box, Chip, Divider } from "@mui/material";
import { SectionViewModal } from "./SectionViewModal";
import moment from "moment";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useSelector } from "react-redux";

export default function InspectionCard({ inspectionForm, getList }) {
    const [selectedItem, setSelectedItem] = useState({});
    const [openSectionModal, setOpenSectionModal] = useState(false);
    const { selectedClientData } = useSelector((state) => state?.main);

    const accentColor = selectedClientData?.AccentColor || "#4F6EF7";

    const handleSectionClick = (item) => {
        setSelectedItem(item);
        setOpenSectionModal(true);
    };

    const isSubmitted = inspectionForm?.isSubmit;

    return (
        <>
            <Box
                onClick={() => handleSectionClick(inspectionForm)}
                sx={{
                    cursor: "pointer",
                    position: "relative",
                    bgcolor: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #ECEEF2",
                    mb: 1.5,
                    px: 2.5,
                    py: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                    transition: "box-shadow 0.2s ease, transform 0.15s ease, border-color 0.2s",
                    overflow: "hidden",
                    "&:hover": {
                        boxShadow: "0 6px 20px rgba(0,0,0,0.09)",
                        transform: "translateY(-1px)",
                        borderColor: `${accentColor}55`,
                    },
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: "4px",
                        borderRadius: "12px",
                        background: isSubmitted
                            ? "linear-gradient(180deg, #34C47C, #22A769)"
                            : `linear-gradient(180deg, ${accentColor}, ${accentColor}BB)`,
                    },
                }}
            >
                {/* Icon bubble */}
                <Box
                    sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        bgcolor: isSubmitted ? "#EDFAF3" : `${accentColor}14`,
                    }}
                >
                    {isSubmitted ? (
                        <CheckCircleIcon sx={{ fontSize: 22, color: "#34C47C" }} />
                    ) : (
                        <EditNoteIcon sx={{ fontSize: 22, color: accentColor }} />
                    )}
                </Box>

                {/* Text content */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: "0.9rem",
                            color: "#1A1D23",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            letterSpacing: "-0.01em", }} variant="subtitle1">
                        {inspectionForm?.formName}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#9499A8",
                            fontSize: "0.75rem",
                            mt: 0.3,
                        }}
                    >
                        Modified {moment(inspectionForm.dateModified).format("MMM DD, YYYY")}
                    </Typography>
                </Box>

                {/* Right: chip + date */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0 }}>
                    {!isSubmitted && (
                        <Chip
                            label="Draft"
                            size="small"
                            sx={{
                                bgcolor: "#FFF8E1",
                                color: "#B7791F",
                                fontWeight: 600,
                                fontSize: "0.7rem",
                                height: 22,
                                border: "1px solid #F6E05E",
                                borderRadius: "6px",
                                "& .MuiChip-label": { px: 1 },
                            }}
                        />
                    )}
                    {isSubmitted && (
                        <Chip
                            label="Submitted"
                            size="small"
                            sx={{
                                bgcolor: "#EDFAF3",
                                color: "#22A769",
                                fontWeight: 600,
                                fontSize: "0.7rem",
                                height: 22,
                                border: "1px solid #9AE6B4",
                                borderRadius: "6px",
                                "& .MuiChip-label": { px: 1 },
                            }}
                        />
                    )}
                </Box>
            </Box>

            {openSectionModal && (
                <SectionViewModal
                    open={openSectionModal}
                    onClose={() => setOpenSectionModal(false)}
                    selectedItem={selectedItem}
                    getList={getList}
                />
            )}
        </>
    );
}